import { Env } from "@/shared/environment/Env";
import { Goto } from "@/shared/navigation/Goto";

/**
 * Fully-qualified URL of a thread's detail page, for a user copying a link to
 * share the thread.
 *
 * The origin comes from the running app rather than a hardcoded
 * ``app.roboto.ai``, so a link copied on a dev stack, a branch deploy, or an
 * isolated-region deployment opens that same stack. The ``Env.appBasePath``
 * prefix matches the basename the router is mounted under; without it the path
 * matches no route on a branch deploy.
 */
export function buildAgentThreadShareLink(threadId: string): string {
  const url = new URL(
    `${Env.appBasePath}${Goto.route.AgentThreads}/${threadId}`,
    window.location.origin,
  );
  return url.toString();
}
